import { useTranslation } from 'react-i18next';
import type { ReportPlaylistBar } from './buildReportRows';

type MostPlayedPlaylistsProps = {
  bars: ReportPlaylistBar[];
};

export function MostPlayedPlaylists({ bars }: MostPlayedPlaylistsProps) {
  const { t } = useTranslation('reports');
  return (
    <section
      className="flex w-full flex-col gap-4 rounded-[14px] border px-6 py-[22px]"
      style={{ background: 'var(--gs-panel)', borderColor: 'var(--gs-line)' }}
    >
      <span className="text-base font-bold">{t('mostPlayed.title')}</span>
      {bars.length === 0 ? (
        <p className="m-0 text-sm" style={{ color: 'var(--gs-muted)' }}>
          {t('mostPlayed.empty')}
        </p>
      ) : (
        bars.map((bar) => (
          <span key={bar.playlistId} className="flex flex-col gap-2">
            <span className="flex justify-between text-[13.5px]">
              <span className="font-semibold">{bar.name || t('untitledPlaylist')}</span>
              <span style={{ color: 'var(--gs-muted)' }}>
                {t('mostPlayed.plays', { count: bar.plays })}
              </span>
            </span>
            <span
              className="block h-[7px] overflow-hidden rounded"
              style={{ background: 'var(--gs-panel2)' }}
            >
              <span
                className="block h-full"
                style={{
                  width: `${bar.widthPct}%`,
                  background: 'var(--gs-accent-solid)',
                }}
              />
            </span>
          </span>
        ))
      )}
    </section>
  );
}
